































































































import { Component, Prop, Inject, Vue } from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import { mask } from 'vue-the-mask';

import Typography from '@/components/atoms/Typography/Typography.vue';
import { formatString } from '@/utils/moneyTreatments';

@Component<TextField>({
  components: { Typography },
  $_veeValidate: {
    value() {
      const { value } = this as any;
      return value;
    },
    name() {
      const { name } = this as any;
      return name;
    }
  },
  directives: {
    mask: (el, binding) => {
      if (!binding.value) return;
      mask(el, binding);
    }
  },
  computed: {
    optionalAfterVar() {
      return {
        '--optional-value': `" (${this.$t(`${this.tPrefix}.optional`)})"`
      };
    }
  }
})
export default class TextField extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'text' }) readonly type!: string;
  @Prop(String) readonly name!: string;
  @Prop(String) readonly icon?: string;
  @Prop(String) value!: string;
  @Prop(String) readonly label!: string;
  @Prop(String) readonly rightText?: string;
  @Prop(String) readonly placeholder!: string;
  @Prop({ default: false }) readonly error!: boolean;
  @Prop(String) readonly maxlength?: string;
  @Prop(String) readonly max?: string;
  @Prop(String) readonly pattern?: string;
  @Prop(String) readonly tippy?: string;
  @Prop(String) readonly mask?: string;
  @Prop(String) readonly autocomplete?: string;
  @Prop(String) readonly inputmode?: string;
  @Prop(Boolean) readonly readonly?: boolean;
  @Prop(String) readonly autocorrect?: string;
  @Prop({ default: false }) readonly autofocus?: boolean;
  @Prop({ default: null }) readonly vueMask?: string;
  @Prop({ default: false }) readonly optional?: boolean;
  @Prop({ default: false }) readonly disabled?: boolean;

  showPassword: boolean = false;

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get tPrefix() {
    return 'common.components.textField';
  }

  get hasRightContent() {
    return !!this.$slots.rightContent;
  }

  onEventScrollInField(event: any) {
    const element = document.activeElement as HTMLInputElement;
    if (
      element &&
      element.type === 'number' &&
      document.elementFromPoint(event.x, event.y) == element
    ) {
      element.blur();
    }
  }

  onEventKeydownInField(event: any) {
    if (event.keyCode === 38 || event.keyCode === 40) {
      event.preventDefault();
    }
  }

  created() {
    if (this.type === 'number') {
      document.addEventListener('wheel', this.onEventScrollInField);
      document.addEventListener('keydown', this.onEventKeydownInField);
    }
  }

  destroy() {
    if (this.type === 'number') {
      document.removeEventListener('wheel', this.onEventScrollInField);
      document.removeEventListener('keydown', this.onEventKeydownInField);
    }
  }

  updateValue(value: string, event: any) {
    const element = event.target;
    if (this.mask) {
      switch (this.mask) {
        case 'phone':
          /*
            mask pattern: +1 XXX XXX-XXXX
          */

          var matchMask = value
            .replace(/\D/g, '')
            .match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/);

          /*
           matchMask[0] - raw value
           matchMask[1] - country code (fixed as +1)
           matchMask[2] - 3-digit area code
           matchMask[3] - 3-digit central office number
           matchMask[4] - 4-digit subscriber number
          */

          if (matchMask) {
            let masked = '+1 ';

            // insert the first value of the input
            if (!this.value) {
              matchMask[2] = matchMask[1];
            }

            if (!matchMask[3]) {
              masked += matchMask[2];
            } else {
              masked +=
                matchMask[2] +
                ' ' +
                matchMask[3] +
                (matchMask[4] ? '-' + matchMask[4] : '');
            }

            event.target.value = masked;
            this.$emit('input', masked);
          }
          return;

        case 'percentage':
          /**
           * Mask Pattern: XX
           */

          var matchMaskPercentage = value
            .replace(/\D/g, '')
            .match(/(\d{0,2})(\d{0,1})/);
          if (matchMaskPercentage) {
            let masked = matchMaskPercentage[1];

            if (
              matchMaskPercentage[1] === '10' &&
              matchMaskPercentage[2] === '0'
            ) {
              masked += matchMaskPercentage[2];
            }

            event.target.value = masked;
            this.$emit('input', masked);
          }
          return;

        case 'currency':
          /**
           * Mask Pattern: XXX.XXX,XX
           */

          var matchMaskCurrency = value.replace(/[^0-9,.]/g, '');
          var masked = formatString(matchMaskCurrency);

          event.target.value = masked;
          this.$emit('input', masked);
          return;
      }
    }

    if (this.maxlength) {
      const newValue = value.substr(0, +this.maxlength);
      event.target.value = newValue;
      this.$emit('input', newValue);
    } else {
      this.$emit('input', value);
    }

    // return cursor when change value
    if (
      this.vueMask &&
      (event.inputType === 'deleteContentBackward' ||
        (event.composed &&
          value.length > 1 &&
          element.selectionStart !== value.length))
    ) {
      const selectionStart = element.selectionStart;
      this.$nextTick(() =>
        element.setSelectionRange(selectionStart, selectionStart)
      );
    }
  }
}
